import React, { useState, forwardRef, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Offcanvas, Form } from 'react-bootstrap';
import swal from "sweetalert";
import Select from "react-select";
import AdminLandsaleService from "../../../API/Services/AdminService/AdminLandsaleService";
import ClipLoader from 'react-spinners/ClipLoader';
import AdminBuilderService from '../../../API/Services/AdminService/AdminBuilderService';
import LazySubdivisionMultiSelect from "../../components/LazySubdivisionMultiSelect";

const BulkLandsaleUpdate = forwardRef((props, ref) => {
    const { selectedLandSales, canvasShowEdit, seCanvasShowEdit } = props;

    const [SubdivisionCode, setSubdivisionCode] = useState([]);
    const [masterPlanCode, setMasterPlanCode] = useState([]);
    const [builderCode, setBuilderCode] = useState([]);
    const [Error, setError] = useState('');
    const [builderListDropDown, setBuilderListDropDown] = useState([]);
    const [masterPlanDropDownList, setMasterPlanDropDownList] = useState([]);
    const [noOfUnit, setNoOfUnit] = useState(null);
    const [price, setPrice] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (canvasShowEdit) {
            GetBuilderDropDownList();
            GetMasterPlanDropDownList();
        }
    }, [canvasShowEdit]);

    const GetBuilderDropDownList = async () => {
        setIsLoading(true);
        try {
            const response = await AdminBuilderService.builderDropDown();
            const responseData = await response.json();
            const formattedData = [
                { label: "Select Builder None", value: "none" }, // Default option
                ...responseData.map((builder) => ({
                    label: builder.name,
                    value: builder.id,
                })),
            ];
            setIsLoading(false);
            setBuilderListDropDown(formattedData);
        } catch (error) {
            setIsLoading(false);
            if (error.name === "HTTPError") {
                const errorJson = await error.response.json();
                setError("Something went wrong!");
            }
        }
    };

    const handleBuilderCode = (code) => {
        setBuilderCode(code);
        setSubdivisionCode([]);
    };

    const GetMasterPlanDropDownList = async () => {
        setIsLoading(true);
        try {
            const response = await AdminBuilderService.masterPlanDropDown();
            const responseData = await response.json();
            setMasterPlanDropDownList([
                { label: "Select Master Plan None", value: "none" },
                ...responseData,
            ]);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            setError("Something went wrong!");
        }
    };

    const handleSubdivisionCode = (code) => {
        setSubdivisionCode(code);

        if (!code || code.value === "none") {
            setMasterPlanCode([]);
            return;
        }

        if (code.masterplan_id) {
            const matchedMasterPlan = masterPlanDropDownList.find(
                (mp) => String(mp.value) === String(code.masterplan_id)
            );

            if (matchedMasterPlan) {
                setMasterPlanCode(matchedMasterPlan);
            } else {
                setMasterPlanCode({
                    label: String(code.masterplan_id),
                    value: code.masterplan_id
                });
            }
        } else {
            setMasterPlanCode({
                label: "Select Master Plan None",
                value: "none"
            });
        }
    };

    const handleMasterPlanCode = (code) => {
        setMasterPlanCode(code);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (selectedLandSales.length === 0) {
            setError('No selected records'); return false
        }
        swal({
            title: "Are you sure?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                try {
                    var userData = {};
                    if (event.target.seller.value) userData.seller = event.target.seller.value;
                    if (event.target.buyer.value) userData.buyer = event.target.buyer.value;
                    if (event.target.location.value) userData.location = event.target.location.value;
                    if (event.target.date.value) userData.date = event.target.date.value;
                    if (event.target.parcel.value) userData.parcel = event.target.parcel.value;
                    if (event.target.price.value) userData.price = event.target.price.value;
                    if (event.target.typeofunit.value) userData.typeofunit = event.target.typeofunit.value;
                    if (event.target.noofunit.value) userData.noofunit = event.target.noofunit.value;
                    if (event.target.notes.value) userData.notes = event.target.notes.value;
                    if (event.target.doc.value) userData.doc = event.target.doc.value;
                    if (event.target.zoning.value) userData.zoning = event.target.zoning.value;
                    if (event.target.lat.value) userData.lat = event.target.lat.value;
                    if (event.target.lng.value) userData.lng = event.target.lng.value;
                    if (event.target.area.value) userData.area = event.target.area.value;
                    if (event.target.zip.value) userData.zip = event.target.zip.value;

                    if (SubdivisionCode?.value === "none") {
                        userData.subdivision_id = null;
                    } else if (SubdivisionCode?.value) {
                        userData.subdivision_id = SubdivisionCode.value;
                    }

                    if (masterPlanCode?.value === "none") {
                        userData.masterplan_id = null;
                    } else if (masterPlanCode?.value) {
                        userData.masterplan_id = masterPlanCode.value;
                    }

                    if (builderCode?.value === "none") {
                        userData.builder_id = null;
                    } else if (builderCode?.value) {
                        userData.builder_id = builderCode.value;
                    }

                    const data = await AdminLandsaleService.bulkupdate(selectedLandSales, userData).json();

                    if (data.status === true) {
                        swal("Records Updated Successfully").then((willDelete) => {
                            if (willDelete) {
                                HandleUpdateCanvasClose();
                                props.parentCallback();
                            }
                        })
                    }
                }
                catch (error) {
                    if (error.name === 'HTTPError') {
                        const errorJson = await error.response.json();
                        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")));
                    }
                }
            }
        })
    };

    const HandleUpdateCanvasClose = () => {
        seCanvasShowEdit(false);
        setError('');
        setSubdivisionCode([]);
        setMasterPlanCode([]);
        setPrice(null);
        setNoOfUnit(null);
        setBuilderCode([]);
    };

    return (
        <Fragment>
            <Offcanvas show={canvasShowEdit} onHide={() => HandleUpdateCanvasClose()} className="offcanvas-end customeoff" placement='end'>
                <div className="offcanvas-header">
                    <h5 className="modal-title" id="#gridSystemModal">{props.Title}</h5>
                    <button type="button" className="btn-close"
                        onClick={() => HandleUpdateCanvasClose()}
                    >
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center mb-5">
                        <ClipLoader color="#4474fc" />
                    </div>
                ) : (
                    <div className="offcanvas-body">
                        <div className="container-fluid">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-xl-6 mb-3">
                                        <label className="form-label">Builder</label>
                                        <Form.Group controlId="tournamentList">
                                            <Select
                                                options={builderListDropDown}
                                                value={builderCode}
                                                placeholder={"Select Builder..."}
                                                onChange={(selectedOption) => handleBuilderCode(selectedOption)}
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        color: 'black'
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        color: 'black'
                                                    }),
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label className="form-label">Subdivision</label>
                                        <Form.Group controlId="tournamentList">
                                            <LazySubdivisionMultiSelect
                                                builderIds={(builderCode?.value === "" || builderCode?.value === undefined || builderCode?.value === null || builderCode?.value === "none") ? [] : [builderCode.value]}
                                                name="subdivision_id"
                                                value={SubdivisionCode}
                                                placeholder={"Select Subdivision..."}
                                                onChange={(selectedOption) => handleSubdivisionCode(selectedOption)}
                                                isMulti={false}
                                                includeNoneOption={true}
                                                noneOptionLabel="Select Subdivision None"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label className="form-label">Master Plan</label>
                                        <Form.Group controlId="masterPlanList">
                                            <Select
                                                options={masterPlanDropDownList}
                                                value={masterPlanCode}
                                                placeholder={"Select Master Plan..."}
                                                onChange={(selectedOption) => handleMasterPlanCode(selectedOption)}
                                                styles={{
                                                    container: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        color: 'black'
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        width: '100%',
                                                        color: 'black'
                                                    }),
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput2" className="form-label">Seller</label>
                                        <input type="text" name='seller' className="form-control" id="exampleFormControlInput2" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput3" className="form-label">Buyer</label>
                                        <input type="text" name='buyer' className="form-control" id="exampleFormControlInput3" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput4" className="form-label">Location</label>
                                        <input type="text" name='location' className="form-control" id="exampleFormControlInput4" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput5" className="form-label">Date</label>
                                        <input type="date" name='date' className="form-control" id="exampleFormControlInput5" placeholder="" />
                                    </div>

                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput6" className="form-label">Parcel</label>
                                        <input type="text" name='parcel' className="form-control" id="exampleFormControlInput6" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput7" className="form-label">Price ($)</label>
                                        <input type="number" name='price' className="form-control" id="exampleFormControlInput7" placeholder="" onChange={(e) => setPrice(e.target.value)} onWheel={(e) => e.currentTarget.blur()} onKeyDown={(e) => (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()} />
                                    </div>

                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput10" className="form-label">Type of Unit</label>
                                        <input type="text" name='typeofunit' className="form-control" id="exampleFormControlInput10" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput11" className="form-label">Price Per Unit ($)</label>
                                        <input type="number" name='priceperunit' disabled style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }} value={noOfUnit ? Math.floor(price / noOfUnit) : 0} className="form-control" id="exampleFormControlInput11" placeholder="" onWheel={(e) => e.currentTarget.blur()} onKeyDown={(e) => (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()} />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput12" className="form-label">No. Of Unit</label>
                                        <input type="number" name='noofunit' className="form-control" id="exampleFormControlInput12" placeholder="" onChange={(e) => setNoOfUnit(e.target.value)} onWheel={(e) => e.currentTarget.blur()} onKeyDown={(e) => (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()} />
                                    </div>

                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput16" className="form-label">Notes</label>
                                        <input type="text" name='notes' className="form-control" id="exampleFormControlInput16" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput17" className="form-label">Doc</label>
                                        <input type="text" name='doc' className="form-control" id="exampleFormControlInput17" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput17" className="form-label">Zoning</label>
                                        <input type="text" name='zoning' className="form-control" id="exampleFormControlInput17" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput17" className="form-label">Latitude</label>
                                        <input type="text" name='lat' className="form-control" id="exampleFormControlInput17" placeholder="" />
                                    </div>

                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput17" className="form-label">Longitude</label>
                                        <input type="text" name='lng' className="form-control" id="exampleFormControlInput17" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput17" className="form-label">Area</label>
                                        <input type="text" name='area' className="form-control" id="exampleFormControlInput17" placeholder="" />
                                    </div>
                                    <div className="col-xl-6 mb-3">
                                        <label htmlFor="exampleFormControlInput17" className="form-label">ZIP Code</label>
                                        <input type="text" name='zip' className="form-control" id="exampleFormControlInput17" placeholder="" />
                                    </div>
                                    <p className='text-danger fs-12'>{Error}</p>
                                </div>
                                <div>
                                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                                    <Link to={"#"} onClick={() => HandleUpdateCanvasClose()} className="btn btn-danger light ms-1">Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </Offcanvas>
        </Fragment>
    );
});

export default BulkLandsaleUpdate;
